import { DataGridLayout, DESC, List } from 'framework/list';
import useFinanceService from 'domain/people/employee/finance/shared/financeService';
import {
  CREATE_COMPENSATION_PACKAGE,
  FE_UPDATE_EMPLOYEE_COMPENSATION_PACKAGES,
  useFinanceUrl,
} from 'domain/people/employee/finance/financeRouting';
import { EmployeeOfficeField } from 'domain/shared/employee';
import { ShowDataInstance } from 'framework/show';
import BaseAmountTypeField from '../shared/fields/BaseAmountTypeField';
import { SensitiveRelationListPageLayout } from 'framework/sensitiveData';
import { CapitalizedField, DateField, TextField } from 'framework/ui/field';
import FinancePackageIdField from 'domain/people/employee/finance/shared/fields/FinancePackageIdField';
import { CreateButton } from 'framework/ui/ui-builder';
import EditFinanceButton from 'domain/people/employee/finance/shared/buttons/EditFinanceButton';
import ViewFinanceButton from 'domain/people/employee/finance/shared/buttons/ViewFinanceButton';

const FinancesList = () => {
  const { search, getSensitiveDataByIds, getIsCurrentPackage } = useFinanceService();
  const { getCreateUrl, getListUrl } = useFinanceUrl();

  return (
    <List getDataMethod={search} defaultSortOrder={DESC} defaultSortField="effectiveDateFrom">
      <SensitiveRelationListPageLayout
        header="Compensation packages"
        headerVariant="h4"
        sensitiveDataIdSource="compensationPackageDataId"
        loadSensitiveDataMethod={getSensitiveDataByIds}
        toggleSensitiveDataButtonProps={{ size: 'small' }}
        actions={[
          <CreateButton
            size="small"
            url={getCreateUrl()}
            label="Add package"
            key="add-package"
            variant="contained"
            permissionToCheck={CREATE_COMPENSATION_PACKAGE}
          />,
        ]}
        timerId={getListUrl()}
      >
        <DataGridLayout
          showTotal={false}
          isSmallTable
          buttons={[
            <EditFinanceButton
              size="small"
              source="id"
              key="edit-finance"
              permissionToCheck={FE_UPDATE_EMPLOYEE_COMPENSATION_PACKAGES}
            />,
            <ViewFinanceButton size="small" source="id" key="view-finance" />,
          ]}
          tableWrapperClassName="finance-list"
          rowProps={(data: ShowDataInstance) => (getIsCurrentPackage(data) ? { className: 'highlighted' } : {})}
        >
          <FinancePackageIdField
            source="id"
            label="Package ID"
            dateFromSource="effectiveDateFrom"
            dateToSource="effectiveDateTo"
            probationAmountSource="probationAmount"
            isSortable
          />
          <CapitalizedField source="type" label="Type" isSortable />
          <DateField source="effectiveDateFrom" label="Effective date from" isSortable />
          <DateField source="effectiveDateTo" label="Effective date to (including)" isSortable />
          <BaseAmountTypeField source="baseAmountType" label="Base amount type" />
          <TextField source="grossAmount" label="Base amount gross" />
          <TextField source="grossProbationAmount" label="Probation value gross" />
          <TextField source="currency" label="Currency" />
          <EmployeeOfficeField source="officeId" label="Office" />
        </DataGridLayout>
      </SensitiveRelationListPageLayout>
    </List>
  );
};

export default FinancesList;
